export function NewChatIcon({
    className,
    color = "white",
}: {
    className?: string;
    color?: string;
}) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M3.33317 15.3333C2.87484 15.3333 2.48248 15.1701 2.15609 14.8438C1.8297 14.5174 1.6665 14.125 1.6665 13.6667V3.66667C1.6665 3.20833 1.8297 2.81597 2.15609 2.48958C2.48248 2.16319 2.87484 2 3.33317 2H16.6665C17.1248 2 17.5172 2.16319 17.8436 2.48958C18.17 2.81597 18.3332 3.20833 18.3332 3.66667V13.6667C18.3332 14.125 18.17 14.5174 17.8436 14.8438C17.5172 15.1701 17.1248 15.3333 16.6665 15.3333H12.229L10.6873 17.625C10.604 17.75 10.5033 17.8437 10.3853 17.9062C10.2672 17.9687 10.1387 18 9.99984 18C9.86095 18 9.73248 17.9687 9.61442 17.9062C9.49637 17.8437 9.39567 17.75 9.31234 17.625L7.77067 15.3333H3.33317ZM9.99984 15.6667L11.3332 13.6667H16.6665V3.66667H3.33317V13.6667H8.6665L9.99984 15.6667Z" fill={color}/>
        </svg>
    );
}
